import api from './api';
import { CPB_URL } from './servers';

export const fetchRecursoArchivo = (data) => api.post(`${CPB_URL}/recursos/getRecurso`, data);
export const fetchListaArchivos = (data) =>
  api.post(`${CPB_URL}/ws/listarArchivosEnCarpetaGestor`, data);
export const fetchEditaArchivo = (data) => api.post(`${CPB_URL}/ws/editaArchivo`, data);
export const fetchEliminaArchivos = (data) => api.post(`${CPB_URL}/ws/eliminaArchivo`, data);
export const fetchAgregaArchivos = (data) => api.post(`${CPB_URL}/ws/agregaArchivo64`, data);
export const fetchEliminaMonitoreos = (data) =>
  api.post(`${CPB_URL}/ws/eliminarCarpetasMonitoreos`, data);
export const fetchEliminaDescargas = (data) =>
  api.post(`${CPB_URL}/ws/eliminarArchivosDescargas`, data);
export const fetchEliminaArchivosTemp = (data) =>
  api.post(`${CPB_URL}/ws/eliminarArchivosTemporales`, data);
export const fetchCreaCarpeta = (data) => api.post(`${CPB_URL}/ws/crearCarpeta`, data);
export const fetchDescarga = (data) => api.post(`${CPB_URL}/ws/descargaArchivo`, data);
export const fetchDescargaZip = (data) => api.post(`${CPB_URL}/ws/descargaArchivosZip`, data);
